import { observer } from 'mobx-react-lite'
import { useEffect, Fragment, useState } from 'react'
import { DownloadOutlined } from '@ant-design/icons'
import './index.css'
import {
  Button,
  Col,
  ConfigProvider,
  Form,
  Input,
  Row,
  Select,
  Space,
  Table,
  DatePicker,
} from 'antd'
import { CommonStore, CallLanguageStore } from '../../../store'
import RowDetail from './rowDetail'
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

// 扩展 dayjs 功能
dayjs.extend(customParseFormat);

function Language() {
  const [form] = Form.useForm()
  const { Column } = Table
  const { Option } = Select
  const { RangePicker } = DatePicker
  const [defaultTime, setDefaultTime] = useState<[dayjs.Dayjs | null, dayjs.Dayjs | null]>([null, null]);

  useEffect(() => {// 获取当前时间
    const now = dayjs().add(1,'day').hour(0).minute(0).second(0);
    // 计算一周前的时间
    const oneWeekAgo = now.subtract(7, 'day');

    // 设置 defaultTime 状态
    setDefaultTime([oneWeekAgo, now]);

    form.setFieldsValue({
      singleItemScrip: null,
      mainCallId:null,
      gradingDescription:null,
      callResult:null,
      callTag:null,
      applicationTime:[oneWeekAgo, now],
    })
    resetSearchBth()

  }, [])
  const getFormData = (changeValue: any, allValues: any) => {
    console.log(changeValue, allValues)

    CallLanguageStore.setSearchForm({ ...allValues })
  }
  //重置
  const resetSearchBth = () => {
    CallLanguageStore.setSearchForm({})
    searchBtn()
  }
  //搜索
  const searchBtn = () => {
    CallLanguageStore.resetPage()
    CallLanguageStore.getLanguagePage()
  }
  return (
    <Fragment>
      <RowDetail></RowDetail>
      <div className="allContent">
        <div className="formContent">
          <Form
            form={form}
            initialValues={CallLanguageStore.searchForm}
            autoComplete="off"
            labelCol={{ span: 6 }}
            onValuesChange={getFormData}
            onKeyDown={(e) => {
              if (e.key.toLowerCase() === 'enter') {
                searchBtn()
              }
            }}
          >
            <Row justify="start">
              <Col span={8}>
                <Form.Item label="话术" name="singleItemScrip">
                  <Select
                    allowClear={true}
                    placeholder="请选择话术"
                    showSearch
                    optionFilterProp="label"
                    options={
                      CallLanguageStore.getAllbotList &&
                      CallLanguageStore.getAllbotList.map((item: any) => ({
                        value: item.botNameEn,
                        label: item.botName
                      }))
                    }
                  ></Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="通话ID" name="mainCallId">
                  <Input placeholder="请输入通话ID" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="意向等级" name="gradingDescription">
                  <Select style={{ width: '98%' }}>
                    <Option value={'有明确意向'}>有明确意向</Option>
                    <Option value={'可能有意向'}>可能有意向</Option>
                    <Option value={'明确拒绝'}>明确拒绝</Option>
                    <Option value={'用户忙'}>用户忙</Option>
                    <Option value={'无效客户'}>无效客户</Option>
                    <Option value={'已加微信'}>已加微信</Option>
                    <Option value={'智能助手'}>智能助手</Option>
                    <Option value={'微信号不是手机号'}>微信号不是手机号</Option>
                    <Option value={'无定级'}>无定级</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="接听状态" name="callResult">
                  <Select style={{ width: '98%' }}>
                    <Option value={71}>未接通</Option>
                    <Option value={72}>接通</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="通话标识" name="callTag">
                  <Input placeholder="请输入通话标识" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item label="呼叫时间" name="applicationTime">
                  <RangePicker
                    showTime
                    style={{ width: '100%' }}
                    placeholder={['开始时间', '结束时间']}
                    defaultValue={defaultTime}
                  />
                </Form.Item>
              </Col>
              <Col offset={2}>
                <Form.Item>
                  <Space>
                    <Button type="primary" onClick={searchBtn}>
                      搜索
                    </Button>
                    <Button htmlType="reset" onClick={resetSearchBth}>
                      重置
                    </Button>
                  </Space>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={8} offset={16}>
                <Button
                  onClick={() => CallLanguageStore.exportError()}
                  type="primary"
                  style={{ float: 'right', marginBottom: '10px' }}
                >
                  <DownloadOutlined />
                  导出
                </Button>
              </Col>
            </Row>
          </Form>
          <ConfigProvider renderEmpty={CommonStore.tableEmptyRender}>
            <Table
              dataSource={CallLanguageStore.tableData.records}
              rowKey={(record) => record.mainCallId}
              loading={CallLanguageStore.tableLoad}
              scroll={{ x: 1300 }}
              pagination={{
                current: CallLanguageStore.pageData.page,
                pageSize: CallLanguageStore.pageData.size,
                onChange: CallLanguageStore.pageData.changePage,
                pageSizeOptions: [10, 20, 50, 100],
                showSizeChanger: true,
                total: CallLanguageStore.tableData.total,
                showTotal: () =>
                  `共计${CallLanguageStore.tableData.total}条`,
                position: ["bottomLeft"],
              }}
            >
              <Column
                fixed="left"
                ellipsis={true}
                width={180}
                title="通话ID"
                dataIndex="mainCallId"
              />
              <Column
                ellipsis={true}
                width={160}
                title="被叫号码"
                dataIndex="phone"
              />
              <Column
                ellipsis={true}
                width={120}
                title="接听状态"
                dataIndex="callResult"
                render={(callResult) =>
                  callResult == 71 ? '未接通' : callResult == 72 ? '接通' : ''
                }
              />
              <Column
                title="通话标识"
                width={150}
                dataIndex="callTag"
                ellipsis={true}
              />
              <Column
                title="意向等级"
                width={150}
                dataIndex="gradingDescription"
                ellipsis={true}
              />
              <Column
                title="用户标签"
                width={150}
                dataIndex="clientTag"
                ellipsis={true}
              />
              <Column
                title="采集信息"
                width={150}
                dataIndex="callSlots"
                ellipsis={true}
              />
              <Column
                title="主叫号码"
                width={150}
                dataIndex="explicitNumber"
                ellipsis={true}
              />
              <Column
                title="通话时长"
                width={180}
                dataIndex="durationInMs"
                ellipsis={true}
              />
              <Column
                title="交互轮次"
                width={150}
                dataIndex="callRounds"
                ellipsis={true}
              />
              <Column
                title="呼叫时间"
                width={180}
                dataIndex="dialTime"
                ellipsis={true}
              />
              <Column
                width={100}
                fixed={"right"}
                align={"right"}
                render={(text: string, record: any) => (
                  <Button
                        size={"small"} 
                        onClick={() =>
                          CallLanguageStore.openDetailModal(record)
                        }
                      >
                        详情
                  </Button>
                )}
              />
            </Table>
          </ConfigProvider>
        </div>
      </div>
    </Fragment>
  )
}
export default observer(Language)
